import { ApiResponse, Venue } from '@collector/sportsapi-client-legacy'

import { HttpClient } from '../httpClient.js'

type VenueGetResponse = ApiResponse<{
  venues: Venue[]
}>

type VenueGetByIdResponse = ApiResponse<{
  venue: Venue
}>

export type VenuesGetQuery = {
  sport_id: number
  short_name?: string
}

export async function get(
  httpClient: HttpClient,
  query: VenuesGetQuery,
): Promise<VenueGetResponse> {
  return httpClient
    .url('/venues')
    .query({
      ...query,
      sort_type: 'short_name',
    })
    .get()
    .json()
}

export async function getById(
  httpClient: HttpClient,
  id: number,
): Promise<VenueGetByIdResponse> {
  return httpClient.url(`/venues/${id}`).get().json()
}
